export default "__VITE_ASSET__fd7a20c8__"